import {Api, Api as CoreApi} from "@bvm/core";

import {messageKeys as EmployeeRegistrationFormKeys} from "./components/form/EmployeeRegistrationForm";
import {messageKeys as EmployeeMutationFormKeys} from "./components/form/EmployeeMutationForm";
import {messageKeys as EmployeeRemovalConfirmKeys} from "./components/form/EmployeeRemovalConfirm";
import {messageKeys as SortableListKeys} from "./components/sortable-list/SortableList";
import {messageKeys as SortableListSearchKeys} from "./components/sortable-list/SortableListSearch";
import {messageKeys as AddEmployeeElementKeys} from "./components/sortable-list/AddEmployeeElement";
import {messageKeys as ConfirmLoginKeys} from "./components/confirm-login/ConfirmLogin";

export function loadI18n(vue) {
    const messagesKeys = [];
    messagesKeys.push(...EmployeeRegistrationFormKeys);
    messagesKeys.push(...EmployeeMutationFormKeys);
    messagesKeys.push(...EmployeeRemovalConfirmKeys);
    messagesKeys.push(...SortableListKeys);
    messagesKeys.push(...SortableListSearchKeys);
    messagesKeys.push(...AddEmployeeElementKeys);
    messagesKeys.push(...ConfirmLoginKeys);
    messagesKeys.push('validations_field_required');
    messagesKeys.push('validations_field_numeric');
    messagesKeys.push('validations_field_length');
    messagesKeys.push('validations_field_integer');
    messagesKeys.push('validations_field_alpha');
    messagesKeys.push('validations_field_alphanumeric');
    messagesKeys.push('validations_field_telephone');
    messagesKeys.push('validations_field_email');
    messagesKeys.push('validations_field_iban');
    messagesKeys.push('validations_field_kvk');
    messagesKeys.push('validations_field_postal');
    messagesKeys.push('validations_field_postal_numeric');

    Api.Lang.bulk(CoreApi.Lang.NL, messagesKeys).then(additionalMessages => {
        vue.$i18n.setLocaleMessage('nl-NL', additionalMessages);
    });
}
